import { render, staticRenderFns } from "./member.vue?vue&type=template&id=851d06aa&scoped=true&"
import script from "./member.vue?vue&type=script&lang=ts&"
export * from "./member.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851d06aa",
  null
  
)

export default component.exports